var path = '/components/empty-info/empty-info.component.html';
var html = "<div class=\"text-center\">\n\t<div class=\"h3\">\n\t\tNo {{ctrl.no || 'content'}}\n\t\t<br/><small>Go add some!</small>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;